import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class ImageUtilService {
  public dataURLtoFile(dataUrl, filename) {
    let arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1];
    let bStr = atob(arr[1]);
    let n = bStr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bStr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
  }
  
  //blob:http://localhost:8087/a4fdce76-78c5-4b96-b837-4d01312f1046
  public async blobURLtoFile(dataUrl, filename, type) {
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    
    // 将 Blob 对象转换为 File 对象
    return  new File([blob], filename, {type: type});
  }
}
